import React from "react";
import { CashAccountsWorkflow } from "./CashEntryWorkflow";

const CashAccountsRequests = () => {
  return (
    <div className="row erp-compact">
      <div className="col-12">
        <div className="cm-content-box box-primary">
          <div className="content-title">
            <div className="cpa">
              <i
                className="bi bi-pencil-square me-2"
                aria-hidden="true"
              />
              Cash Amendments & Date Access
            </div>
          </div>

          <div className="cm-content-body">
            <div className="card-body p-3">
              <CashAccountsWorkflow standalone />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CashAccountsRequests;